<!-- loading-overlay.component.html -->
<div class="loading-overlay">
  <div
    class="diagonal-background diagonal-background-1 animate__animated animate__fadeOutRight"
  ></div>
  <div
    class="diagonal-background diagonal-background-2 animate__animated animate__fadeOutLeft"
  ></div>
  <div class="content"></div>
</div>

<!-- <h1 class="pulse">Zodi</h1> -->
